import { useOpenProject } from './useOpenProject'

export const useProjectItemProps = (project, { onClick }) => {
  const openProject = useOpenProject()
  return {
    onClick: async e => {
      onClick(e)
      await openProject(project?.id)
    },
  }
}
